ui-cms-newsletter-cta {
  display: block;
  container-type: inline-size;

  .sd-headline {
    margin: 0;
  }

  sd-button {
    width: 100%;

    @container ( min-width: #{$small}) {
      width: auto;
    }
  }

  form {
    display: flex;
    flex-direction: column;
    padding-top: $sd-spacing-3;
    gap: $sd-spacing-3;

    @container ( min-width: #{$small}) {
      flex-direction: row;
      align-items: end;
    }
  }
}
